import { Component } from '@angular/core';
import { BaseComponent } from "../../../shared";

@Component({
  selector: 'product-buttons',
  templateUrl: './productButtonsContainerComponent.html'
})
export class ProductButtonsContainerComponent extends BaseComponent  {

}